import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { RoutesPaths } from "../Router/Constant";
import { useLanguage } from "../Router/LanguageContext";
// import { getDictionary } from "../getDictionary";

export default function Header() {
  const location = useLocation(); // 👈 detect route change
  const [menuVisible, setMenuVisible] = useState(false);
  const [scrolled, setScrolled] = useState(false); // 👈 NEW
  const { dictionary, changeLanguage, lang } = useLanguage();

  useEffect(() => {
    setMenuVisible(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const languages = [
    { code: "pg", label: "PT" },
    { code: "en", label: "EN" },
    { code: "fr", label: "FR" },
  ];

  const LanguageSwitcher = ({ languages, lang, changeLanguage }) => {
    return (
      <div className="languageTranslationHeader">
        {languages.map((item, index) => (
          <React.Fragment key={item.code}>
            <p
              className={`m-0 f-s-18 f-w-500 ${
                lang === item.code ? "languageActive" : ""
              }`}
              onClick={() => changeLanguage(item.code)}
            >
              {item.label}
            </p>

            {index !== languages.length - 1 && (
              <div className="languageLine"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div className={`headerShadowSection ${scrolled ? "headerScrolled" : ""}`}>
      <div className="container-fluid maxContainerSection headerRowSection">
        <div className="row">
          <div className="col-md-12 headerOuterSection">
            <div className="quimenergylogo">
              <Link to={RoutesPaths.LANDING}>
                <img src="/assets/img/quimenergylogo.svg" alt="" />
              </Link>

              <div className="visibleMobile" onClick={toggleMenu}>
                <img src="/assets/img/threeLine.svg" alt="" />
              </div>
            </div>

            <div>
              <div
                className={`routerPathSection ${
                  menuVisible ? "showMenu" : "hideMenu"
                }`}
              >
                <Link
                  to={RoutesPaths.LANDING}
                  className={`f-s-18 ${
                    location.pathname === RoutesPaths.LANDING ? "activeTab" : ""
                  }`}
                >
                  {dictionary?.home}
                </Link>
                <Link
                  to={RoutesPaths.ABOUTUS}
                  className={`f-s-18 ${
                    location.pathname === RoutesPaths.ABOUTUS ? "activeTab" : ""
                  }`}
                >
                  {dictionary?.aboutUs}
                </Link>
                <div className="ourSolutionTabOuter">
                  <div
                    className={`f-s-18 ourSolutionTab ${
                      location.pathname === RoutesPaths.RENEWABLEENERGY ||
                      location.pathname === RoutesPaths.OILGAS ||
                      location.pathname === RoutesPaths.EPC
                        ? "activeTab"
                        : ""
                    }`}
                  >
                    {dictionary?.ourSolutions}
                    <svg
                      width="12"
                      height="7"
                      viewBox="0 0 12 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.833313 0.833328L5.83331 5.83333L10.8333 0.833328"
                        stroke={
                          location.pathname === RoutesPaths.RENEWABLEENERGY ||
                          location.pathname === RoutesPaths.OILGAS ||
                          location.pathname === RoutesPaths.EPC
                            ? "#0076cb"
                            : "#000000"
                        }
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>

                  <div className="ourSolutionTabInner">
                    <p className="m-0">
                      <Link
                        to={RoutesPaths.RENEWABLEENERGY}
                        className={`f-s-18 ${
                          location.pathname === RoutesPaths.RENEWABLEENERGY
                            ? "activeTab"
                            : ""
                        }`}
                      >
                        {dictionary?.renewableEnergy}
                      </Link>
                    </p>
                    <div className="ourSolutionTabInnerHr"></div>
                    <p className="m-0">
                      <Link
                        to={RoutesPaths.OILGAS}
                        className={`f-s-18 ${
                          location.pathname === RoutesPaths.OILGAS
                            ? "activeTab"
                            : ""
                        }`}
                      >
                        {dictionary?.oilAndGas}
                      </Link>
                    </p>
                    <div className="ourSolutionTabInnerHr"></div>
                    <p className="m-0">
                      <Link
                        to={RoutesPaths.EPC}
                        className={`f-s-18 ${
                          location.pathname === RoutesPaths.EPC
                            ? "activeTab"
                            : ""
                        }`}
                      >
                        {dictionary?.epcInfrastructure}
                      </Link>
                    </p>
                  </div>
                </div>

                {/* <Link
                to={RoutesPaths.DENIRA}
                className={`f-s-18 ${location.pathname === RoutesPaths.DENIRA ? "activeTab" : ""
                  }`}
              >
                Denira
              </Link> */}
                <Link
                  to={RoutesPaths.ESG}
                  className={`f-s-18 ${
                    location.pathname === RoutesPaths.ESG ? "activeTab" : ""
                  }`}
                >
                  {dictionary?.esg}
                </Link>

                <Link
                  to={RoutesPaths.CONTACTUS}
                  className={`f-s-18 ${
                    location.pathname === RoutesPaths.CONTACTUS
                      ? "activeTab"
                      : ""
                  }`}
                >
                  {dictionary?.contactUs}
                </Link>

                <div className="visibleMobile">
                  <LanguageSwitcher
                    languages={languages}
                    lang={lang}
                    changeLanguage={changeLanguage}
                  />
                </div>
              </div>
            </div>

            <div className="desktopView widthContentSec">
              {/* <Link to={RoutesPaths.CONTACTUS} className="radius-btn">
                  <span className="btn-text">{dictionary?.contactUs}</span>
                </Link> */}
              <LanguageSwitcher
                languages={languages}
                lang={lang}
                changeLanguage={changeLanguage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
